






























import Logo from 'library/components/globals/logo'
import PrimaryLinks from './primary-links'
import NewsletterSignup from 'library/components/globals/newsletter-signup'
import Logos from './logos'

export default
	components: {
		Logo
		PrimaryLinks
		NewsletterSignup
		Logos
	}

	computed:
		footerData: -> @$store.state.globals.footer

	methods:
		scrollToTop: ->
			window.scrollTo 0, 0

